<template>  
  <div class="examStart"> 
    <span class="examStart-span"></span>
    <div class="examStart-div">
        <img src="../../assets/exam/examCenter.png" alt="" class="examStart-img">
        <!-- <h1>Examination Centre</h1> -->
        <div class="examStart-div-div">
            <h2>考试须知</h2>
            <p>考试介绍：</p>
            <p>考试规则：</p>
            <div>剩余考试次数：两次</div>
            <div>当前考试成绩：85分</div>
            <button>开始考试</button>
        </div>
    </div>

        
  </div>
</template>

<script>
export default {
  name: 'examStart',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .examStart{
      background-image:url("https://static.wixstatic.com/media/a36401_d8fd7ef9f61c4903a1120e56b1e63ff3~mv2_d_3900_3900_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_d8fd7ef9f61c4903a1120e56b1e63ff3~mv2_d_3900_3900_s_4_2.webp");
      height:1200px;
      width:100%;
      position: relative;
      background-repeat: no-repeat;
      background-size: cover;
  }
  .examStart .examStart-span{
      height: 1200px;
      width: 100%;
      background-color: #000;
      opacity: 0.6;
      position: absolute;
      top:0;
      left: 0;
  }
  .examStart-div{
      width: 980px;
      position: absolute;
      z-index:1;
      top:0;
      left:50%;
      margin-left: -490px;
      color:rgb(232, 230, 230);
      
  }
  .examStart-div .examStart-img{
      margin-top:50px;
      margin-bottom: 100px;
  }
  .examStart-div h1{
    color: #E8E6E6;
    font-size: 45px;
    font-weight:normal;
    font-family: roboto-thin,roboto,sans-serif;
  }
  .examStart-div .examStart-div-div{
      width:600px;
      margin: 0 auto;
      background-color: rgba(0, 0, 0, 0.3);
      padding-left: 40px;
      padding-right: 40px;
      border-radius: 15px;
      text-align: center;
      padding-bottom: 40px;
  }
  .examStart-div .examStart-div-div h2{
      text-align: center;
      font-weight: 500;
      font-size: 20px;
      padding-top:40px;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(65, 65, 65, 1);

  }
  .examStart-div .examStart-div-div p{
      margin-top:30px;
      font-size: 14px;
      height: 250px;
      border-bottom:1px solid rgba(65, 65, 65, 1);
      text-align: left;
  }
  .examStart-div .examStart-div-div p:nth-child(3){
      border-bottom: 0;
  }
  .examStart-div .examStart-div-div div{
      font-size: 14px;
      text-align: center;
      line-height: 30px;
  }
  .examStart-div .examStart-div-div button{
      margin-top:30px;
      width: 80px;
      height: 30px;
      background-color: unset;
      border: solid rgba(250, 250, 250, 1) 1px;
      border-radius: 20px;
      color:#FAFAFA;
      line-height: 27px;
  }
  .examStart-div .examStart-div-div button:hover{
      transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
      background-color: #fafafa;
      color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/examStart.vue